import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Estado vacio para listados sin resultados.
 *
 * Un listado vacio sin explicacion se lee como un error de carga; este bloque
 * dice que no hay nada y, si procede, que hacer al respecto.
 */
@Component({
  selector: 'app-empty-state',
  imports: [],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmptyStateComponent {
  /** Nombre del icono de Bootstrap Icons, sin el prefijo `bi-`. */
  readonly icon = input<string>('inbox');

  /** Titulo corto y afirmativo. */
  readonly title = input<string>('Sin resultados');

  /** Explicacion o siguiente paso sugerido. */
  readonly message = input<string>('No hay informacion para mostrar por ahora.');
}
